// Built-in geometry/material libraries. The canonical definitions live in
// the engine asset (crates/wasm/assets/builtin_libraries.json, exported via
// builtinLibrariesJson) so the editor and native renderers (fluveria-cli,
// future desktop) share one source. The JSON was generated from the original
// TS definitions and is edited directly from now on.

import { builtinLibrariesJson } from 'fluveria-engine-wasm';
import type { LibraryGeometryDef, LibraryMaterialDef } from '../scene/layerState.js';
import type { AppState } from '../state/appState.js';

interface BuiltinLibrariesPayload {
  geometry: Record<string, LibraryGeometryDef>;
  materials: Record<string, LibraryMaterialDef>;
  shapes?: AppState['builtInShapes'];
}

export function initializeBuiltInLibraries(appState: AppState): void {
  const payload = JSON.parse(builtinLibrariesJson()) as BuiltinLibrariesPayload;
  appState.geometryLibrary.builtIn = payload.geometry;
  appState.materialLibrary.builtIn = payload.materials;
  appState.builtInShapes = payload.shapes ?? {};
}
